import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, Link, useParams, useLocation } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  Icon,
  Typography
} from '@material-ui/core';
import { useStyles } from '../styles';
import SearchPatient from '../QuotePatient/SearchPatient';


const QuoteSummaryPatient = () => {
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const classes = useStyles();
  const history = useHistory();
  const {id} = useParams<{ [id: string]: string }>();
  const {pathname} = useLocation();

  const {
    currentQuoteCustomer,
  } = useSelector((state: IReduxState) => state.quote);

  const phone = currentQuoteCustomer?.custom_attributes?.find((attr) => attr.attribute_code === 'phone_number')?.value || '';
  const [searchPatientModalOpen, setSearchPatientModalOpen] = useState(false);

  return (
    <Card className="px-4 pt-4 pb-6 root-card">
      <Box display="flex" justifyContent="space-between" alignItems="baseline">
        <Typography variant="h6" className={`${classes.patientTitle} w-full`}>{isCustomer3 ? 'Customer' : 'Patient'}</Typography>
        <div className="w-full flex items-center justify-end flex-wrap">
          {pathname.includes('summary') &&
            <Button
              component={Link}
              to={`/quoting/profile/${id}/quote-workspace/patient-activity`}
              color="primary"
              size="small"
              className={classes.patientName}
              startIcon={<Icon>recent_actors</Icon>}
            >
              {isCustomer3 ? 'Customer Activity' : 'Patient Activity'}
            </Button>
          }
          <Button
            component={Link}
            to="#"
            onClick={() => setSearchPatientModalOpen(true)}
            color="primary"
            size="small"
            className={classes.patientName}
            startIcon={<Icon>account_circle</Icon>}
          >
            {`Change ${isCustomer3 ? 'customer' : 'patient'}`}
          </Button>
        </div>
      </Box>
      <Grid className={`${classes.bgDeepBlue} px-4 py-2 mt-2`}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" className={classes.patientName}>
            {currentQuoteCustomer?.firstname}&nbsp;
          </Typography>
          <Typography variant="subtitle1" className={classes.patientName}>
            {currentQuoteCustomer?.lastname}
          </Typography>
          <Box flexGrow={1} textAlign="right">
            <Icon
              className="cursor-pointer"
              onClick={() => history.push({pathname: '/quoting/'})}
            >
              close
            </Icon>
          </Box>
        </Box>
        <Divider />
        <Box display="flex" alignItems="center" mt={3}>
          <Icon>email</Icon>
          <Typography variant="body1" className={classes.patientInfo}>
            {currentQuoteCustomer?.email}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" mt={2}>
          <Icon>phone</Icon>
          <Typography variant="body1" className={classes.patientInfo}>
            {phone}
          </Typography>
        </Box>
      </Grid>
      <SearchPatient open={searchPatientModalOpen} onClose={() => setSearchPatientModalOpen(false)} />
    </Card>
  );
};

export default QuoteSummaryPatient;
